// authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const registerSlice  = createSlice({
  name: 'register',
  initialState: {
    provider: null,
    consumer: null,
  },
  reducers: {
    registerProvider: (state, action) => {
      state.provider = action.payload;
    },
    registerConsumer: (state, action) => {
      state.consumer = action.payload;
    }
  },
});

export const { registerProvider,registerConsumer } = registerSlice.actions;
export const selectProvider = (state) => state.register.provider
export const selectConsumer = (state) => state.register.consumer;

export default registerSlice.reducer;
